import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import client from 'api/client'
import * as Actions from 'redux/actions'
import store from 'redux/store'
import { Workspace } from 'types'
import { WorkspaceClient } from '../clients/WorkspaceClient'

export const WorkspaceService = {
  getWorkspaces: async () => {
    const response = await client.getUserWorkspaces()
    if (response.type === SUCCESS_RESPONSE_TYPE) {
      store.dispatch(Actions.workspacesSet(response.data.workspaces))
    }
    return response
  },
  leave: async (key: string) => {
    const response = await WorkspaceClient.leave(key)

    if (response.type === 'success') {
      const workspaces = store.getState()['workspace']['workspaces'].filter((workspace) => workspace.key !== key)

      store.dispatch(Actions.workspacesSet(workspaces))
    }

    return response
  },

  markAsSeen: async (workspaceKey: Workspace['key']) => {
    const res = await WorkspaceClient.markAsSeen(workspaceKey)
    if (res.type === SUCCESS_RESPONSE_TYPE) store.dispatch(Actions.markWorkspaceAsSeen(workspaceKey))
  },

  hideSidebar: () => {
    store.dispatch(Actions.closeSidebar())
    store.dispatch(Actions.setFloatingSidebar(false))
  },
}
